'use client';
import React from 'react';

const conditions = [
  'Anxiety & Panic Attacks',
  'Depression & Low Mood',
  'Obsessive Compulsive Disorder',
  'Social Anxiety',
  'Phobias & Agoraphobia',
  'Health Anxiety',
  'Stress & Adjustment',
  'Relationship Difficulties',
  'Low Self-Esteem',
  'Loss & Bereavement',
  'Trauma & PTSD',
  'Life Transitions',
];

export default function MentalHealthSection() {
  return (
    <section
      className="w-full"
      style={{ backgroundColor: '#1A2332', paddingTop: 'clamp(64px, 8vw, 112px)', paddingBottom: 'clamp(64px, 8vw, 112px)' }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 clamp(24px, 4vw, 64px)' }}>

        {/* Header row */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end gap-8 lg:gap-20" style={{ marginBottom: 'clamp(40px, 5vw, 64px)' }}>
          <div style={{ flex: '0 0 auto', maxWidth: '480px' }}>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: '11px',
                letterSpacing: '0.16em',
                textTransform: 'uppercase',
                color: '#8A9E8C',
                marginBottom: '16px',
              }}
            >
              Areas of Specialism
            </p>
            <h2
              style={{
                fontFamily: 'orpheus-pro, Georgia, serif',
                fontSize: 'clamp(26px, 3.2vw, 48px)',
                fontWeight: '400',
                color: '#E8D8D5',
                lineHeight: '1.2',
              }}
            >
              Bringing focus to your mental health &amp; well-being
            </h2>
          </div>
          <div style={{ flex: 1 }}>
            <p
              style={{
                fontFamily: 'adobe-garamond-pro, Georgia, serif',
                fontSize: 'clamp(15px, 1.2vw, 18px)',
                color: 'rgba(239,227,225,0.6)',
                lineHeight: '1.75',
                maxWidth: '440px',
              }}
            >
              Dr Morgan is highly trained to use evidence-based psychological methods for a wide range of difficulties. If you don&apos;t see your concern listed, please get in touch.
            </p>
          </div>
        </div>

        {/* Conditions grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
            gap: '0',
            borderTop: '1px solid rgba(245,240,234,0.1)',
          }}
        >
          {conditions.map((condition, idx) => (
            <div
              key={idx}
              style={{
                padding: 'clamp(16px, 2vw, 24px) clamp(16px, 2vw, 24px)',
                borderBottom: '1px solid rgba(245,240,234,0.1)',
                borderRight: '1px solid rgba(245,240,234,0.1)',
              }}
            >
              <span
                style={{
                  display: 'block',
                  fontFamily: 'adobe-garamond-pro, Georgia, serif',
                  fontSize: 'clamp(14px, 1.1vw, 17px)',
                  color: 'rgba(239,227,225,0.75)',
                  lineHeight: '1.5',
                }}
              >
                {condition}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{ marginTop: 'clamp(32px, 4vw, 48px)' }}>
          <a
            href="/contact"
            style={{
              fontFamily: 'adobe-garamond-pro, Georgia, serif',
              fontSize: '13px',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: '#1A2332',
              backgroundColor: '#E8D8D5',
              padding: '14px 32px',
              textDecoration: 'none',
              display: 'inline-block',
              transition: 'background-color 0.25s ease',
            }}
            onMouseEnter={e => ((e.currentTarget as HTMLElement).style.backgroundColor = '#DFD0CC')}
            onMouseLeave={e => ((e.currentTarget as HTMLElement).style.backgroundColor = '#E8D8D5')}
          >
            Arrange an Initial Consultation
          </a>
        </div>
      </div>
    </section>
  );
}
